"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateUploadCard = void 0;
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const TemplateUploadCard = ({ onUpload }) => {
    const [mouseIsOver, setMouseIsOver] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const fileInputRef = (0, react_1.useRef)(null);
    const templateDiv = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (templateDiv) {
            const width = templateDiv.current.offsetWidth;
            templateDiv.current.style.minHeight = `${width + width / 4}px`;
            templateDiv.current.style.height = `${width + width / 4}px`;
        }
    }, []);
    const handleClick = () => {
        var _a;
        if (!loading) {
            (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    const handleFileChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        // Validate file type
        if (file.type !== "application/pdf") {
            alert("Please upload a PDF file");
            return;
        }
        // Validate file size (10MB max)
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            alert("File size must be less than 10MB");
            return;
        }
        try {
            setLoading(true);
            yield onUpload(file);
            // Reset file input
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
        catch (error) {
            console.error("Upload error:", error);
            alert("Upload failed. Please try again.");
        }
        finally {
            setLoading(false);
        }
    });
    return (react_1.default.createElement("div", { onMouseEnter: () => setMouseIsOver(true), onMouseLeave: () => setMouseIsOver(false), ref: templateDiv, className: `relative transition ease-in-out delay-150 w-full bg-white shadow-md flex flex-col items-center justify-center cursor-pointer border-2 border-dashed ${loading
            ? "border-gray-300 opacity-50 cursor-not-allowed"
            : mouseIsOver
                ? "border-secondary hover:-translate-y-1 hover:scale-110 duration-300"
                : "border-gray-300"}`, onClick: handleClick },
        react_1.default.createElement("input", { ref: fileInputRef, type: "file", accept: ".pdf", onChange: handleFileChange, className: "hidden", disabled: loading }),
        loading ? (react_1.default.createElement("div", { className: "flex flex-col items-center justify-center" },
            react_1.default.createElement("div", { className: "w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin mb-2" }),
            react_1.default.createElement("span", { className: "text-sm text-gray-600" }, "Uploading..."))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faFileArrowUp, className: "text-5xl text-gray-400 mb-3" }),
            react_1.default.createElement("span", { className: "text-sm text-center text-gray-600 px-4" }, "Upload Template"),
            react_1.default.createElement("span", { className: "text-xs text-center text-gray-400 px-4 mt-1" }, "PDF only, max 10MB")))));
};
exports.TemplateUploadCard = TemplateUploadCard;
